import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate, Outlet } from "react-router-dom";
import {
  LayoutDashboard, Globe, Users, Mail, Calendar, Shirt, Clock,
  Wallet, Gift, Image as ImageIcon, Music, Settings, LogOut, Wand2, Shield,
  LayoutGrid, Video, TrendingUp, CreditCard, Store, Trophy,
  MessageCircle, PlayCircle, Heart, MapPin, Scale, BellRing, FileDown, Sparkles, Megaphone, Film, Mic,
  Share2, Swords, ShieldCheck, Activity, FlagTriangleRight, Send, ScrollText, Building, Crown, FileText, Radio, Menu, MoreHorizontal,
  Receipt, Phone, Inbox, ListChecks, Briefcase, Star, FileSpreadsheet, GraduationCap, BookOpen, Presentation, Award,
} from "lucide-react";
import { motion } from "framer-motion";
import { useAuth } from "../../lib/auth";
import { api } from "../../lib/api";
import { BrandLogo } from "../../components/Navbar";
import { haptic } from "../../lib/haptics";
import { useViewAs, setViewAs, VIEWS } from "../../lib/viewAs";


const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/dashboard/planning-hub", label: "Planning Hub", icon: ListChecks },
  { to: "/dashboard/saved-vendors", label: "Saved Vendors", icon: Heart },
  { to: "/dashboard/ai-planner", label: "AI Planner", icon: Sparkles },
  { heading: "Planning" },
  { to: "/dashboard/timeline", label: "Timeline", icon: Clock },
  { to: "/dashboard/events", label: "Events", icon: Calendar },
  { to: "/dashboard/budget", label: "Budget", icon: Wallet },
  { to: "/dashboard/quotes", label: "Compare Quotes", icon: Scale },
  { to: "/dashboard/seating", label: "Seating Chart", icon: LayoutGrid },
  { to: "/dashboard/dress-tux", label: "Dress & Tux", icon: Shirt },
  { to: "/dashboard/travel", label: "Travel & Helpers", icon: MapPin },
  { to: "/dashboard/contacts", label: "Contacts", icon: Users },
  { to: "/dashboard/reports", label: "Reports", icon: TrendingUp },
  { heading: "Guests & Invites" },
  { to: "/dashboard/guests", label: "Guests", icon: Users },
  { to: "/dashboard/rsvps", label: "RSVPs", icon: Mail },
  { to: "/dashboard/invitations", label: "Invitations", icon: Mail },
  { to: "/dashboard/invites", label: "Animated Invites", icon: Sparkles },
  { to: "/dashboard/guest-messages", label: "Guest Messages", icon: MessageCircle },
  { to: "/dashboard/wedding-party", label: "Wedding Party", icon: Crown },
  { to: "/dashboard/party-messages", label: "Roster Inbox", icon: MessageCircle },
  { to: "/dashboard/announcements", label: "Announcements", icon: Megaphone },
  { heading: "Website & Gifts" },
  { to: "/dashboard/website", label: "Website", icon: Globe },
  { to: "/dashboard/registry", label: "Registry", icon: Gift },
  { to: "/dashboard/payouts", label: "Payouts", icon: Wallet },
  { to: "/dashboard/thank-yous", label: "Thank-You Notes", icon: Heart },
  { to: "/dashboard/marketplace", label: "Consignment", icon: Store },
  { heading: "Memories & Social" },
  { to: "/dashboard/memories", label: "Memories", icon: ImageIcon },
  { to: "/dashboard/reels", label: "Wedding Reels", icon: Film },
  { to: "/dashboard/videos", label: "Video Memories", icon: PlayCircle },
  { to: "/dashboard/blessings", label: "Guest Blessings", icon: Mic },
  { to: "/dashboard/share-studio", label: "Share Studio", icon: Share2 },
  { to: "/dashboard/love-story", label: "Love Story", icon: Heart },
  { to: "/dashboard/album", label: "Keepsake Album", icon: FileDown },
  { to: "/dashboard/anniversary", label: "Anniversaries", icon: BellRing },
  { to: "/community/me", label: "My Social Wall", icon: Users },
  { to: "/hub", label: "Social Center", icon: Users },
  { to: "/messages", label: "Messages", icon: MessageCircle },
  { heading: "Live & Video" },
  { to: "/dashboard/live", label: "Go Live", icon: Radio },
  { to: "/dashboard/sessions", label: "Live Sessions", icon: Video },
  { to: "/dashboard/reception-mode", label: "Reception Mode", icon: Radio },
  { to: "/dashboard/party-games", label: "Party Games", icon: Swords },
  { heading: "Couple Connection" },
  { to: "/dashboard/vow-studio", label: "Vow Studio", icon: Wand2 },
  { to: "/dashboard/concierge", label: "AI Concierge", icon: MessageCircle },
  { to: "/dashboard/quiz", label: "Compatibility (Lite)", icon: Sparkles },
  { to: "/dashboard/compatibility", label: "Locked In Compat.", icon: Heart },
  { to: "/dashboard/locked-in", label: "Locked In Q's", icon: MessageCircle },
  { to: "/dashboard/locked-in/challenges", label: "Couple Challenge", icon: Swords },
  { to: "/dashboard/therapy", label: "Therapy", icon: Heart },
  { heading: "Rewards" },
  { to: "/dashboard/club", label: "Couples Club", icon: Trophy },
  { to: "/contest", label: "$25K Wedding Contest", icon: Trophy },
  { to: "/dashboard/wallet", label: "Points Wallet", icon: Wallet },
  { to: "/dashboard/referrals", label: "Affiliate", icon: TrendingUp },
  { heading: "Account" },
  { to: "/call-center", label: "Call Center", icon: Phone, sales: true },
  { to: "/dashboard/conference", label: "Conference Center", icon: Video, staff: true },
  { to: "/dashboard/sales-admin", label: "Sales & Marketing", icon: Megaphone, sales: true },
  { to: "/seo-center", label: "SEO & Google Rankings", icon: Globe, sales: true },
  { to: "/dashboard/profile", label: "My Profile", icon: Users },
  { to: "/dashboard/vendor-profile", label: "Vendor Profile", icon: Store, role: ["vendor", "admin"] },
  { to: "/dashboard/vendor-inbox", label: "Couple Inbox", icon: Inbox, role: ["vendor", "admin"] },
  { to: "/dashboard/planner-page", label: "My Portfolio", icon: Briefcase, role: ["planner", "admin"] },
  { to: "/dashboard/preferred-vendors", label: "Preferred Vendors", icon: Star, role: ["planner", "admin"] },
  { to: "/dashboard/estimates", label: "Estimates & Invoices", icon: FileSpreadsheet, role: ["vendor", "planner", "admin"] },
  { to: "/dashboard/onboarding", label: "Onboarding", icon: ShieldCheck, role: ["vendor"] },
  { to: "/dashboard/my-agreements", label: "My Agreements", icon: FileText },
  { to: "/dashboard/invoices", label: "Orders & Invoices", icon: Receipt },
  { to: "/dashboard/billing", label: "Billing", icon: CreditCard },
  { to: "/dashboard/settings", label: "Settings", icon: Settings },
];

// Admin-specific nav — shown when user.role === "admin"
const ADMIN_NAV = [
  { to: "/dashboard/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/dashboard/admin/go-live", label: "Go-Live To Do", icon: ListChecks },
  { to: "/dashboard/admin/views", label: "All Views", icon: Globe },
  { heading: "Training" },
  { to: "/call-center?tab=academy&view=manage", label: "Manage Training", icon: GraduationCap },
  { to: "/call-center?tab=academy&view=manual", label: "Training Manual", icon: BookOpen },
  { to: "/call-center?tab=academy&view=onboarding", label: "Onboarding Decks", icon: Presentation },
  { to: "/call-center?tab=academy&view=classes", label: "Live Classes", icon: Video },
  { to: "/call-center?tab=academy&view=learn", label: "My Training", icon: Award },
  { heading: "People" },
  { to: "/dashboard/admin/profiles", label: "All Profiles", icon: Users },
  { to: "/dashboard/admin/users", label: "Users & Plans", icon: Users },
  { to: "/dashboard/admin/weddings", label: "Weddings", icon: Building },
  { to: "/dashboard/admin/vendors", label: "Vendor Approvals", icon: Store },
  { to: "/dashboard/contacts", label: "My Contacts", icon: Users },
  { heading: "Safety" },
  { to: "/dashboard/admin/moderation", label: "Moderation", icon: ShieldCheck },
  { to: "/dashboard/admin/reports", label: "Reports", icon: FlagTriangleRight },
  { to: "/dashboard/admin/community", label: "Community", icon: Users },
  { to: "/dashboard/admin/audit", label: "Audit Log", icon: ScrollText },
  { heading: "Growth & Money" },
  { to: "/call-center", label: "Call Center", icon: Phone },
  { to: "/dashboard/conference", label: "Conference Center", icon: Video },
  { to: "/dashboard/sales-admin", label: "Sales Admin", icon: Megaphone },
  { to: "/seo-center", label: "SEO & Google Rankings", icon: Globe },
  { to: "/dashboard/admin/insights", label: "Insights", icon: TrendingUp },
  { to: "/dashboard/admin/revenue", label: "Revenue", icon: TrendingUp },
  { to: "/dashboard/admin/invoices", label: "All Invoices", icon: Receipt },
  { to: "/dashboard/admin/platform-reports", label: "Platform Reports", icon: TrendingUp },
  { to: "/contest", label: "Wedding Contest", icon: Trophy },
  { heading: "Content" },
  { to: "/dashboard/admin/homepage", label: "Homepage", icon: Globe },
  { to: "/admin", label: "Studio (Content)", icon: Shield },
  { to: "/dashboard/admin/blog", label: "Blog Editor", icon: FileText },
  { to: "/dashboard/admin/podcast", label: "Podcast", icon: Mic },
  { to: "/dashboard/admin/broadcast", label: "Broadcast", icon: Send },
  { to: "/dashboard/announcements", label: "Announcements", icon: Megaphone },
  { heading: "Services" },
  { to: "/dashboard/admin/therapy", label: "Therapy", icon: Heart },
  { to: "/dashboard/admin/notifications", label: "Notifications", icon: Send },
  { to: "/dashboard/admin/agreements", label: "Agreements", icon: FileText },
  { to: "/dashboard/settings", label: "My Settings", icon: Settings },
];

// Mobile bottom-nav: 5 most-used. Native-app feel.
const BOTTOM_NAV = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard, end: true },
  { to: "/dashboard/rsvps", label: "RSVPs", icon: Mail },
  { to: "/dashboard/locked-in", label: "Games", icon: MessageCircle },
  { to: "/dashboard/memories", label: "Vault", icon: ImageIcon },
];

// Planners & vendors get a business dashboard; couples keep the wedding tools.
const PRO_PATHS = new Set(["/dashboard", "/dashboard/contacts", "/dashboard/reports", "/dashboard/timeline", "/dashboard/events", "/dashboard/budget",
  "/dashboard/vendor-profile", "/dashboard/vendor-inbox", "/community", "/messages", "/dashboard/my-agreements", "/dashboard/live", "/dashboard/share-studio",
  "/dashboard/announcements", "/dashboard/referrals", "/dashboard/wallet", "/dashboard/billing", "/dashboard/settings", "/dashboard/invoices", "/dashboard/payouts", "/call-center", "/admin/vendor-intelligence", "/dashboard/conference", "/dashboard/onboarding", "/dashboard/sales-admin", "/dashboard/profile", "/dashboard/planner-page", "/dashboard/preferred-vendors", "/dashboard/estimates"]);
const PRO_ONLY = new Set(["/dashboard/reports", "/dashboard/vendor-profile", "/dashboard/planner-page", "/dashboard/preferred-vendors", "/dashboard/estimates"]);
const PRO_BOTTOM_NAV = [
  { to: "/dashboard", label: "Home", icon: LayoutDashboard, end: true },
  { to: "/dashboard/contacts", label: "Clients", icon: Users },
  { to: "/dashboard/reports", label: "Reports", icon: TrendingUp },
  { to: "/messages", label: "Inbox", icon: MessageCircle },
];

const ADMIN_BOTTOM_NAV = [
  { to: "/dashboard/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/dashboard/admin/moderation", label: "Mod", icon: ShieldCheck },
  { to: "/dashboard/admin/weddings", label: "Sites", icon: Building },
  { to: "/dashboard/admin/revenue", label: "Revenue", icon: TrendingUp },
];

export default function DashboardLayout() {
  const { user, logout, loading, refresh } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [cold, setCold] = useState(0);
  const viewAs = useViewAs(user);
  const proUser = ["vendor", "planner"].includes(user?.role);
  useEffect(() => {
    if (!proUser) return;
    const f = () => api.get("/contacts/follow-ups").then((r) => setCold(r.data.length)).catch(() => {});
    f();
    window.addEventListener("lif:cold-leads", f);
    return () => window.removeEventListener("lif:cold-leads", f);
  }, [proUser, location.pathname]);

  useEffect(() => {
    if (!loading && !user) {
      // try refresh once then redirect
      refresh().then((u) => {
        if (!u) nav("/login", { replace: true });
      });
    }
  }, [user, loading, nav, refresh]);
  useEffect(() => { if (user?.role === "applicant") nav("/careers/me", { replace: true }); }, [user, nav]);


  if (loading || !user) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-[var(--gold)] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  const isAdmin = user.role === "admin" && viewAs === "admin";
  const isPro = ["vendor", "planner"].includes(user.role) || viewAs === "planner";
  const adminPaths = new Set(ADMIN_NAV.map((i) => i.to));
  const raw = isAdmin ? [...ADMIN_NAV, { heading: "Our Wedding" }, ...NAV.map((i) => (i.heading ? { heading: `Wedding · ${i.heading}` } : i)).filter((i) => i.heading || (!PRO_ONLY.has(i.to) && !adminPaths.has(i.to) && i.to !== "/dashboard/billing"))] : isPro ? NAV.filter((i) => i.heading || PRO_PATHS.has(i.to)) : NAV.filter((i) => i.heading || !PRO_ONLY.has(i.to));
  const allowed = raw.filter((i) => i.heading || ((!i.role || i.role.includes(user.role)) && (!i.sales || user.role === "admin" || user.sales_rep) && (!i.staff || ["admin", "therapist"].includes(user.role) || user.sales_rep)));
  const navItems = allowed.filter((i, k) => !i.heading || (allowed[k + 1] && !allowed[k + 1].heading));
  const bottomItems = isAdmin ? ADMIN_BOTTOM_NAV : isPro ? PRO_BOTTOM_NAV : BOTTOM_NAV;

  return (
    <div className="min-h-screen bg-[var(--bg)] flex">
      {/* Sidebar */}
      <aside data-testid="dashboard-sidebar" className={`fixed lg:static inset-y-0 left-0 z-50 lg:z-30 w-72 bg-white border-r border-[var(--line)] transform transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
        <div className="p-6 border-b border-[var(--line)]">
          <Link to="/" className="flex items-center gap-2">
            <BrandLogo />
          </Link>
          {isAdmin && (
            <p className="mt-3 text-[10px] uppercase tracking-[0.22em] text-[var(--gold)] flex items-center gap-1">
              <ShieldCheck className="w-3 h-3" /> Admin Console
            </p>
          )}
          {viewAs && (
            <label className="mt-3 flex items-center gap-2 text-[11px] text-[var(--muted)]">View as
              <select value={viewAs} onChange={(e) => { setViewAs(e.target.value); nav("/dashboard"); }} className="flex-1 border border-[var(--line)] rounded-full px-2 py-1 text-xs bg-white" data-testid="sidebar-view-as">{VIEWS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
            </label>
          )}
        </div>
        <nav className="p-4 space-y-1 overflow-y-auto" style={{ maxHeight: "calc(100vh - 200px)" }}>
          {navItems.filter((item) => item.heading || !item.role || item.role.includes(user.role)).map((item) => item.heading ? (
            <p key={item.heading} className="pt-5 pb-1 px-3 text-[10px] uppercase tracking-[0.22em] text-[var(--gold)]" data-testid={`sidebar-heading-${item.heading.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}>{item.heading}</p>
          ) : (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`sidebar-${item.label.toLowerCase().replace(/[^a-z]+/g, "-").replace(/^-|-$/g, "")}`}
              className={({ isActive }) => `sidebar-item ${isActive ? "active" : ""}`}
              onClick={() => setOpen(false)}
            >
              <item.icon className="w-4 h-4" strokeWidth={1.6} />
              <span>{item.label}</span>
              {isPro && item.to === "/dashboard/contacts" && cold > 0 && <span className="ml-auto text-[10px] min-w-5 h-5 px-1.5 rounded-full bg-amber-500 text-white flex items-center justify-center" data-testid="sidebar-cold-leads-badge" title="Leads quiet for a week">{cold}</span>}
            </NavLink>
          ))}
        </nav>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-[var(--line)] bg-white">
          <div className="flex items-center gap-3 mb-3 px-2">
            <div className="w-9 h-9 rounded-full bg-[var(--bg-warm)] flex items-center justify-center text-[var(--gold)] font-serif">
              {(user.name || user.email)[0]?.toUpperCase()}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium truncate">{user.name || "Couple"}</p>
              <p className="text-xs text-[var(--muted)] truncate">{user.email}</p>
            </div>
          </div>
          <button
            data-testid="sidebar-logout"
            onClick={async () => { await logout(); nav("/"); }}
            className="sidebar-item w-full"
          >
            <LogOut className="w-4 h-4" />
            <span>Log Out</span>
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0 lg:ml-0 flex flex-col min-h-screen">
        <header className="lg:hidden sticky top-0 z-20 flex items-center justify-between px-4 py-2.5 bg-white/85 backdrop-blur-xl border-b border-[var(--line)]">
          <button onClick={() => setOpen(o => !o)} data-testid="dashboard-menu-btn" aria-label="Open menu" className="w-10 h-10 rounded-full flex items-center justify-center active:bg-black/5"><Menu className="w-5 h-5" /></button>
          <Link to="/" data-testid="dashboard-logo"><BrandLogo /></Link>
          <Link to="/dashboard/settings" data-testid="dashboard-avatar" className="w-9 h-9 rounded-full bg-[var(--bg-warm)] flex items-center justify-center text-[var(--gold)] font-serif">{(user.name || user.email || "")[0]?.toUpperCase()}</Link>
        </header>
        <main className="flex-1 min-w-0 p-5 md:p-10 lg:p-12 overflow-x-hidden pb-28 lg:pb-12">
          {viewAs && viewAs !== "admin" && (
            <div className="mb-5 flex items-center justify-between gap-3 rounded-xl bg-[#111] text-white px-4 py-2.5 text-xs" data-testid="view-as-banner">
              <span>You're viewing as a <b className="text-[var(--gold)]">{viewAs === "host" ? "wedding host" : "client planner"}</b>. Admin access is unchanged.</span>
              <button onClick={() => { setViewAs("admin"); nav("/dashboard"); }} className="underline text-[var(--gold)]" data-testid="view-as-exit">Back to admin</button>
            </div>
          )}
          <motion.div key={location.pathname} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.3 }}>
            <Outlet />
          </motion.div>
        </main>
      </div>

      {open && <div className="lg:hidden fixed inset-0 z-20 bg-black/40 backdrop-blur-sm" onClick={() => setOpen(false)} data-testid="sidebar-backdrop" />}

      {/* Mobile bottom nav — native app feel */}
      <nav
        data-testid="dashboard-bottom-nav"
        className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/85 backdrop-blur-xl border-t border-[var(--line)] flex justify-around px-1 pt-1"
        style={{ paddingBottom: "max(0.4rem, env(safe-area-inset-bottom))" }}
      >
        {bottomItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={() => haptic()}
            data-testid={`bottomnav-${item.label.toLowerCase()}`}
            className="relative flex-1 flex flex-col items-center gap-0.5 py-1.5 text-[10px] uppercase tracking-[0.14em]"
          >
            {({ isActive }) => (
              <>
                {isActive && <motion.span layoutId="dash-tab-pill" className="absolute inset-x-1.5 inset-y-0.5 rounded-2xl bg-[#C8A96B]/12" transition={{ type: "spring", stiffness: 500, damping: 38 }} />}
                <item.icon className={`relative w-5 h-5 ${isActive ? "text-[var(--gold)]" : "text-[var(--muted)]"}`} strokeWidth={1.6} />
                <span className={`relative ${isActive ? "text-[var(--ink)]" : "text-[var(--muted)]"}`}>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
        <button onClick={() => { haptic(); setOpen(true); }} data-testid="bottomnav-more" className="flex-1 flex flex-col items-center gap-0.5 py-1.5 text-[10px] uppercase tracking-[0.14em] text-[var(--muted)]">
          <MoreHorizontal className="w-5 h-5" strokeWidth={1.6} />
          <span>More</span>
        </button>
      </nav>
    </div>
  );
}
